import { render, staticRenderFns } from "./CreateCampaignSourceCollection.vue?vue&type=template&id=1ce11a0d&scoped=true"
import script from "./CreateCampaignSourceCollection.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceCollection.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceCollection.vue?vue&type=style&index=0&id=1ce11a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce11a0d",
  null
  
)

export default component.exports